import React from 'react'
import { UpsideDownVCompImg } from '../../img/UpsideDownVCompImg'
import { TwoLoopsImg } from '../../img/TwoLoopsImg'
import { CircleLineImg } from '../../img/CircleLineImg'
import { HourglassBigImg } from '../../img/HourglassBigImg'
import { StarCompImg } from '../../img/StarCompImg'
import { SquareLoopsImg } from '../../img/SquareLoopsImg'
import { PineTreeImg } from '../../img/PineTreeImg'
import { SunImg } from '../../img/SunImg'
import { ASquareImg } from '../../img/ASquareImg'
import styles from './intro.module.css'
import { TISGroupBigImg } from '../../img/TISGroupBigImg'
import { HavasGroupBigImg } from '../../img/HavasGroupBigImg'
import { useTheme } from '../../context/ThemeContext'

export const IntroComponent = ({ projectData }) => {
  if (!projectData) {
    return <div>Loading...</div>
  }
  const { theme } = useTheme()

  const companyName = theme === 'okb' ? 'The Interactive Studio' : 'Havas Media Network'

  return (
    <div className={styles['HAV-web']}>
      <div className={styles.squares}>
        <div className={styles['wrap-squares']}>
          <div className={styles['square-row']}>
            <div className={styles.element}>
              <HourglassBigImg width={'248'} height={'248'} />
            </div>
            <div className={styles.element}>
              <UpsideDownVCompImg />
            </div>
            <div className={styles['element-square-loops']}>
              <SquareLoopsImg />
            </div>
          </div>
          <div className={styles['square-row']}>
            <div className={styles['element-pine-tree']}>
              <PineTreeImg />
            </div>
            <div className={styles.element}>
              <TwoLoopsImg width={'248'} height={'248'} />
            </div>
            <div className={styles.element}>
              <SunImg />
            </div>
          </div>

          <div className={styles['square-row']}>
            <div className={styles.element}>
              <CircleLineImg width={'248'} height={'248'} />
            </div>
            <div className={styles.element}>
              <ASquareImg />
            </div>
            <div className={styles.element}>
              <StarCompImg />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.frame}>
        <div className={styles.div}>
          {theme === 'okb'
            ? (
              <TISGroupBigImg className={`${styles.group}`} alt="Group" src="group.png" />
              )
            : (
              <HavasGroupBigImg className={`${styles.group} ${styles.havasGroup}`} alt="Group" src="group.png" />
              )}
          <div className={styles['text-wrapper']}></div>
        </div>
        <div className={styles['div-2']}>
          <div className={styles['div-3']}>
            <div className={styles.div}>
              <div className={styles['text-wrapper-2']}>Project</div>
              <div className={styles['text-wrapper-3']}>{projectData.name}</div>
            </div>
            <div className={styles.div}>
              <div className={styles['text-wrapper-2']}>{projectData.scope ? 'Scope' : 'Jira ID'}</div>
              <div className={styles['text-wrapper-3']}>{projectData.scope ? projectData.scope : projectData.jiraId}</div>
            </div>
          </div>
          <div className={styles['web-accessibility']}>
            Web <br />
            accessibility <br />
            analysis
          </div>
          <div className={styles['NOTICE-proprietary-wrapper']}>
            <p className={styles['NOTICE-proprietary']}>
              <span className={styles.span}>
                NOTICE: Proprietary &amp; Confidential
                <br />
                All the content of this document (text, figures, lists, financial information, graphics, design, diagrams,
                as well as other graphic elements and/or audio and videos), whichever the format used (paper or
                electronic), is confidential and proprietary to {companyName}. This document includes ideas and
                information based on the experience, know-how, intellectual/creative effort of {companyName}. For
                these reasons, this material shall not be used, reproduced, copied, disclosed, transmitted, transformed,
                commercialized or communicated, in whole or in part, neither to third parties nor to the public, without
                the express and written consent of {companyName}.
                <br />
                <br />
              </span>
              <span className={styles['text-wrapper-3']}>
                {companyName} © All rights reserved
                <br />
              </span>
              <span className={styles.span}>
                This presentation is not a contractual proposal and has no binding effects for any
                company until a final and written contract is entered into between the parties.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
